<template>
  <div class="text-right">
    <h3 class="text-left">Metodo de envío</h3>
    <hr />
    <div class="list-group text-left">
      <div
        href="#"
        class="list-group-item"
        v-show="metodoEnvio.id == 2"
        :class="metodoEnvio.id == 2 ? 'bg-blue' : 'bg-disabled py-4'"
      >
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">Recoger en domicilio</h5>
        </div>
        <div v-show="metodoEnvio.id == 2" class="pt-4">
          <p v-show="pickUp.address">
            Direccion de recolección: {{ pickUp.address }}
          </p>
          <p v-show="pickUp.phone">Numero de telefono: {{ pickUp.phone }}</p>
          <p v-show="pickUp.date">
            Días y horarios de recolección: {{ pickUp.date }}
          </p>
        </div>
      </div>
      <div
        href="#"
        v-show="metodoEnvio.id == 1"
        class="list-group-item"
        :class="metodoEnvio.id == 1 ? 'bg-blue' : 'bg-disabled py-4'"
      >
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">Guía prepagada de Sistema Apple</h5>
        </div>
        <p class="mb-1" v-show="metodoEnvio.id == 1">
          Envío Nacional: SC$15.00<br />
          Envío a de Ciudad de México: SC$12.00
        </p>
      </div>
      <div
        class="list-group-item"
        v-show="metodoEnvio.id == 4"
        :class="metodoEnvio.id == 4 ? 'bg-blue' : 'bg-disabled py-4'"
      >
        <h5>Costo de envío acordado con el comprador</h5>
      </div>
      <div
        href="#"
        class="list-group-item"
        v-show="metodoEnvio.id == 0 || metodoEnvio.id == 3"
        :class="
          metodoEnvio.id == 0 || metodoEnvio.id == 3
            ? 'bg-blue'
            : 'bg-disabled py-4'
        "
      >
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">
            {{
              metodoEnvio.id == 0
                ? "Envío acordado por el vendedor"
                : "Envío acordado con el vendedor (Costo de envío fijo)"
            }}
          </h5>
        </div>
        <div v-show="metodoEnvio.id == 0 || metodoEnvio.id == 3" class="pt-4">
          <p>
            Envíos a:
            <span v-show="metodoEnvio.sellerPlaceWorld">todo el mundo</span>
            <span v-for="country in metodoEnvio.countries" :key="country"
              >{{ country }}
            </span>
          </p>
          <p>
            Costo de envío:
            {{ metodoEnvio.price ? `SC$${shippingPriceSC}` : "Gratis" }}
          </p>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between">
      <span class="btn btn-secondary mt-4" @click="handleBackSteep"
        >Volver</span
      >
      <span class="btn btn-treid mt-4 d-none" @click="handleNextSteep"
        >Continuar</span
      >
    </div>
  </div>
</template>

<script>
import countries from "../../configs/countries.js";
import { LC } from "../../tools/exchange";
export default {
  name: "shippingInfo",
  props: {},
  data() {
    return {
      localCurrency: null,
      items: [],
      pickUp: {
        address: "",
        phone: "",
        date: "",
      },
      metodoEnvio: {
        id: 0,
        name: "",
        countries: [],
        sellerPlaceWorld: false,
      },
    };
  },
  methods: {
    handleBackSteep() {
      this.$parent.backSteep();
    },
    handleNextSteep() {
      this.$parent.nextSteep(this.metodoEnvio.id == 2 ? 2 : 1);
    },
  },
  computed: {
    shippingPriceSC() {
      if (this.localCurrency)
        return this.localCurrency
          .localToSC({
            price: this.metodoEnvio.price,
            currency: this.items[0].currency,
          })
          .toFixed(2);
      return 0;
    },
  },
  created: function() {
    LC.new().then((localCurrency) => {
      this.localCurrency = localCurrency;
    });

    this.items = this.$parent.cartItems;
    if (!this.items.length) return;

    // Buscamos el metodo del primer producto
    let metodo = null;
    for (let i = 0; i < this.items.length && !metodo; i++) {
      if (this.items[i].kind == "product") {
        metodo = this.items[i];
      }
    }

    if (!metodo || metodo.shippingType == 2) {
      return this.$parent.nextSteep(2);
    }

    const listCountries = metodo.sellerPlaces.map((e) =>
      countries.find((f) => f.iso3 == e)
        ? countries.find((f) => f.iso3 == e).nombre
        : ""
    );

    const buyerCountry = countries.find(
      (e) => e.iso3 == this.$parent.auth.pais
    );
    this.metodoEnvio = {
      id: metodo.shippingType,
      name:
        metodo.shippingType == 0
          ? "manual"
          : metodo.shippingType == 1
          ? "Guia prepagada de Sistema Apple"
          : "Recoger en domicilio",
      price: Number(metodo.shippingPrice),
      countries: listCountries,
      countryIncludeBuyer: buyerCountry,
      sellerPlaceWorld: metodo.sellerPlaceWorld,
    };

    this.pickUp = {
      ...this.pickUp,
      ...this.items[0].pickUp,
    };
  },
};
</script>
